/**
 * @ngdoc services
 * @memberof mercury.modules.settings
 * @name CompanyPreferences
 * @description Data access service for updating company preferences
 */
angular.module('mercury.modules.settings.company')
.factory('CompanyPreferences', ["$http", "userinfo", "settings", function($http, userinfo, settings) {

  /**
   * Update multiple company preferences
   *
   * @memberof CompanyPreferences
   * @param  {Object} preferences Array of preferences to update
   * @param  {String} companyId   Id of the company the preferences belong to
   */
  function updateMany(preferences, companyId) {
    var promise;
    if (companyId) {
      promise = $http.post(settings.mercHost + '/preferences', preferences, {headers: {'x-loaded-company-id': companyId}, params: {isArray: 'true'}});
    } else {
      promise = $http.post(settings.mercHost + '/preferences', preferences, {params: {isArray: 'true'}});
    }

    promise.then(function() {
      angular.forEach(preferences, function(preference) {
        userinfo.companyPreferenceSet(preference, companyId);
      });
    });

    return promise;
  }

  return {
    updateMany: updateMany
  };
}]);
